export async function timeout(delay: number) {
  return await new Promise((res) => setTimeout(res, delay))
}
